import {
  CaddySelectionCriteria,
  CaddyData,
  TeeTimeBookingOptions,
  TeeTimeBooking,
  BuggyType,
  BookingPlayerType,
} from './../../../../data/mygolf.data';
import {
  ModalController,
  NavController,
  NavParams,
  PopoverController,
} from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { GameRoundInfo } from '../../../../data/game-round';
import { CompetitionInfo } from '../../../../data/competition-data';
import {
  TeeTimeSlotDisplay,
  DisplayPrices,
  CurrencyData,
  TeeTimeBookingPlayer,
} from '../../../../data/mygolf.data';
import { MessageDisplayUtil } from '../../../../message-display-utils';
import { ToastController } from '@ionic/angular';
import { Platform } from '@ionic/angular';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

/*
 Generated class for the CompetitionDescriptionPage page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */

export interface BookingBuggy {
  buggySlot: number;
  driving: boolean;
  bookingPlayer?: TeeTimeBookingPlayer;
  pairingNo: number;
  walking: boolean;
  totalPlayers: number;
  maxAllowed: number;
}
export interface BookingCaddy {
  caddySelectionCriteria?: CaddySelectionCriteria;
  caddyPreferred?: CaddyData;
  caddyAssigned?: CaddyData;
  caddiePreferred?: number;
  caddieAssigned?: number;
  caddyRequired?: boolean;
  caddyRequested?: boolean;
  caddyPairing?: number;
}

export interface CaddyPairing {
  caddySelectionCriteria?: CaddySelectionCriteria;
  caddyPreferred?: CaddyData;
  caddyAssigned?: CaddyData;
  caddiePreferred?: number;
  caddieAssigned?: number;
  caddyRequired?: boolean;
  caddyRequested?: boolean;
  caddyPairing?: number;
}

@Component({
  templateUrl: 'buggy-seating.page.html',
  selector: 'buggy-seating-page',
  styleUrls: ['buggy-seating.page.scss'],
})
export class BuggySeatingPage implements OnInit {
  public competition: CompetitionInfo;
  public gameRound: Array<GameRoundInfo>;
  public headerName: string;

  teeSlot: TeeTimeSlotDisplay;
  prices: DisplayPrices;
  currency: CurrencyData;
  buggies: Array<BookingBuggy>; //: Array<number>;// = [1,2,3,4]
  caddies: Array<BookingCaddy>;
  type: string = 'buggy';
  caddyPairing: Array<CaddyPairing> = new Array<CaddyPairing>();
  bookingOptions: TeeTimeBookingOptions;
  slot: TeeTimeBooking;
  override: boolean = false;
  filteredBuggyTypes: Array<BuggyType> = new Array<BuggyType>();
  buggyTypes: Array<BuggyType> = new Array<BuggyType>();
  playerType: BookingPlayerType;

  constructor(
    public nav: NavController,
    private modalCtl: ModalController,
    private popoverCtl: PopoverController,

    private navParams: NavParams,
    private toastCtl: ToastController,
    private platform: Platform,
    private mg2uUtil: mygolfUtils,
  ) {

    this.competition = this.navParams.get('competition');
    this.gameRound = this.navParams.get('gameRound');
    this.headerName = this.navParams.get('headerName');

    this.buggies = this.navParams.get('buggies');
    this.caddies = this.navParams.get('caddies');
    this.bookingOptions = this.navParams.get('bookingOptions');
    this.slot = this.navParams.get('slot');

    this.type = this.navParams.get('type');

    if (this.type === 'caddy')
      this.caddyPairing = this.navParams.get('pairing');
    this.override = this.navParams.get('override');

    this.buggyTypes = this.navParams.get('buggyTypes');
    this.playerType = this.navParams.get('playerType');

    if (this.buggyTypes && this.buggyTypes.length > 0) {
      this.filteredBuggyTypes = this.buggyTypes.filter((type) => {
        if (type && this.playerType) {
          let _noAssignable: boolean = false;
          let _bgyPlayerType;
          if (type.assignableTo && type.assignableTo.length > 0) {
            _bgyPlayerType = type.assignableTo.filter((pType) => {
              return pType.toLowerCase() === this.playerType.id.toLowerCase();
            });
            _noAssignable = false;
          } else if (type.assignableTo && type.assignableTo.length === 0) {
            _noAssignable = true;
          }
          return (_bgyPlayerType && _bgyPlayerType.length > 0) || _noAssignable;
        } else return true;
      });
    }
    // this.teeSlot = this.navParams.get("slot");
    // this.prices = this.teeSlot.displayPrices;
    // this.currency = this.teeSlot.currency;
  }

  close() {
    if(this.modalCtl.getTop())
      this.modalCtl.dismiss({
        selected: false,
      });
    if(this.popoverCtl.getTop()) {
      this.popoverCtl.dismiss({
        selected: false
      })
    }
  }

  selectBuggy(buggy: BookingBuggy) {
    // if(buggy.totalPlayers >= buggy.maxAllowed) {
    //     MessageDisplayUtil.showMessageToast('Selected buggy has maxed allowed ('+buggy.maxAllowed+')',
    //                       this.platform, this.toastCtl,3000, "bottom")
    //                       return false;
    // }
    this.modalCtl.dismiss({
      selected: true,
      buggy: buggy,
    });
  }
  selectCaddy(caddy: BookingCaddy) {
    this.modalCtl.dismiss({
      selected: true,
      caddy: caddy,
    });
  }

  ngOnInit() { }

  getInnerHTML() {
    let description =
      "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>";
    return description;
  }

  clearCaddy(caddy: BookingCaddy) {
    caddy = {
      caddySelectionCriteria: null,
      caddyPreferred: null,
    };
  }

  getBuggySlot(b: BookingBuggy, i: number, attribute?: string) {
    let _textWalk = "Walking";
    if (this.getWalkingOrOwnBuggyNaming()) _textWalk = this.getWalkingOrOwnBuggyNaming();
    switch (attribute) {
      case 'displayname':
        if (i === 0) return _textWalk;
        else return 'Buggy #' + b.buggySlot;
      case 'currentplayers':
        return b.totalPlayers;
      case 'maxallowed':
        return b.maxAllowed;
      default:
        if (i === 0) return 'Walking';
        else return 'Buggy #' + b.buggySlot;
    }

    // Buggy {{buggy.buggySlot}}
  }
  getCaddyPreferred(caddy: BookingCaddy, i: number) {
    let _caddySelectionCriteria: Array<CaddySelectionCriteria> =
      this.caddyPairing
        .filter((cp) => {
          return cp.caddyPairing === caddy.caddyPairing && !cp.caddyPreferred;
        })
        .map((cp) => {
          return cp.caddySelectionCriteria;
        });
    let _caddyPreferred: Array<CaddyData> = this.caddyPairing
      .filter((cp) => {
        return cp.caddyPairing === caddy.caddyPairing && cp.caddyPreferred;
      })
      .map((cp) => {
        return cp.caddyPreferred;
      });

    if (_caddyPreferred[0] && _caddyPreferred[0].firstName) {
      return _caddyPreferred[0].firstName;
    } else if (
      _caddySelectionCriteria[0] &&
      _caddySelectionCriteria[0].gender
    ) {
      return (
        (_caddySelectionCriteria[0].gender === 'F' ? 'Female' : 'Male') +
        ', Age btwn ' +
        _caddySelectionCriteria[0].minAge +
        ' and ' +
        _caddySelectionCriteria[0].maxAge
      );
    } else return '';
  }
  getFilteredBuggyTypes() {
    let _filtered;
    let _itemToFind = 'STANDARD';
    let _foundIdx = this.filteredBuggyTypes.findIndex(
      (bt) => bt.typeId === _itemToFind
    );
    let _stdBuggy = this.filteredBuggyTypes[_foundIdx];
    this.filteredBuggyTypes.splice(_foundIdx, 1);
    this.filteredBuggyTypes.unshift(_stdBuggy);
    _filtered = this.filteredBuggyTypes;
    // _filtered = this.filteredBuggyTypes.map((bt => bt.typeId))
    // .sort((a,b)=>{
    //     if(a === 'STANDARD' && b !== 'STANDARD') return -1
    //     else if(a !== 'STANDARD' || b != 'STANDARD') {
    //         if(a < b) return -1
    //         else if(a > b) return 1
    //         else return 0
    //     }

    // })

    return _filtered;
  }
  selectBuggyType(type) {
    this.popoverCtl.dismiss({
      selected: true,
      buggyType: type,
    });
  }
  getWalkingOrOwnBuggyNaming() {
    let _textWalk = 'Walk';
    let _appAttribute;
    _appAttribute = this.mg2uUtil.getSpecificAppAttributePage('bookingDetails');
    if (_appAttribute && _appAttribute.labels && _appAttribute.labels.flightWalking) _textWalk = _appAttribute.labels.flightWalking;
    return _textWalk;
  }
}
